<div class="Inter-Medium sp-font-size-32 sp-top-padding-12 sp-left-padding-24" style="letter-spacing: 0px;
color: #444444; padding-top: px;">
  Please help us serve you better!
</div>
<div class="sp-font-size-14 sp-top-padding-27 sp-bottom-padding-12 sp-left-padding-24 Inter-Regular" style="letter-spacing: 0px;
color: #444444; padding-top: 27px;">
  Choose a reason or add your reason about why you dislike the video.
</div>
<hr />
<div style="color: #707070; padding-top: 12px" class="intro-wrapper sp-left-padding-24">
  <div class="reason-1">
    <mat-checkbox [(ngModel)]="reason1" value="" color="primary">Reason1</mat-checkbox>
  </div>
  <div class="reason-2">
    <mat-checkbox [(ngModel)]="reason2" value="" color="primary">Reason2</mat-checkbox>
  </div>
  <div class="reason-3">
    <mat-checkbox [(ngModel)]="reason3" value="" color="primary">Reason3</mat-checkbox>
  </div>
  <div class="reason-4">
    <mat-checkbox [(ngModel)]="reason4" value="" color="primary">Reason4</mat-checkbox>
  </div>
  <div class="reason-5">
    <mat-checkbox [(ngModel)]="reason5" value="" color="primary">My Reason is not listed here.</mat-checkbox>
  </div>
</div>
<mat-form-field id="content" class="Inter-Regular sp-bottom-padding-12" style="border: 1px solid #CFCFCF; border-radius: 5px; width: 100%; margin-bottom: 8px; background: #F7F7F7 0% 0% no-repeat padding-box;">
  <mat-label>Please mention your reason here...</mat-label>
  <textarea matInput rows="3" autocomplete="off" maxlength="1000" formControlName="feedbackDescription" class="feedback-textarea"></textarea>
</mat-form-field>
<hr />
<div style="margin-top: 16px; margin-bottom: 10px;">
  <button [ngClass]="{'opacity-btn': !(reason1 || reason2 || reason3 || reason4 || reason5)}" [disabled]="!(reason1 || reason2 || reason3 || reason4 || reason5)" class="secondary-btn submit-btn" mat-raised-button (click)="closeFeedbackDialog()">
    Submit
  </button>
</div>
